define('components/Navigation',[
    "jquery",
    "logging",
    "utilities"
], function($, logging, utilities) {
    var _ModuleName = "Navigation";

    function Navigation(scope) {
        "use strict";

        var $navigation = $(scope);

        // This component JavaScript is primarily to force dependency injection that
        // initializes the Navigation, however any JavaScript that needs to run on the 
        // navigation can be placed here as well

        if (utilities.IsMobile() === true){
            $("#search .search-button").click(function(){
                 $("#search input").removeClass("hidden-xs");
            });
            $(".writer-theme").click(function(){
                 $("#search input").addClass("hidden-xs");
            });
        }

        ;
    }

    /**
     * Initialize component JavaScript
     * @param {*} args 
     */
    return {
        init: function init(args) {
            ;
            return new Navigation(args.scope);
        }
    }
});
